import { render, staticRenderFns } from "./NewErrand.vue?vue&type=template&id=36e83ae0&"
import script from "./NewErrand.vue?vue&type=script&lang=js&"
export * from "./NewErrand.vue?vue&type=script&lang=js&"
import style0 from "./NewErrand.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports